import { 
	ChangePasswordData, ChangePasswordResponse, IChangePassword,
} from "@/types/models/services/user/changePassword";

import {
	KnownProfileDataResponses,
	ProfileData,
	ProfileDataV1
} from "@/components/User/types/profile";

import API from "./api";
import { IVersionedResponse } from "@/types/definitions/apiCalls";

export enum Endpoints {
	ProfileData = "/users/",
	ChangePassword = "/user/password",
}

const changePassword = ({
	currentPassword,
	newPassword
}: IChangePassword) => {
	return new Promise<ChangePasswordResponse>(async (resolve, reject) => {
		API.put<ChangePasswordResponse, ChangePasswordData>({
			endpoint: Endpoints.ChangePassword,
			data: {
				current: currentPassword, 
				password: newPassword
			}
		})
		.then(res => {
			if(res.promise.data.status === "ERROR") {
				reject(res.promise.data);
			} else {
				resolve(res.promise.data);
			}
		})
		.catch(err => {
			reject(err);
		})
	})
}

const getProfileData = () => {

	// Returns one of the Known Profile Data Responses
	return new Promise<KnownProfileDataResponses>(async (resolve, reject) => {

		// Indicates all Known Profile Data Responses
		API.get<KnownProfileDataResponses>({
			endpoint: Endpoints.ProfileData,
			versions: [1, 2],
			currentVersion: 2
		})
		.then(res => {
			switch( res.version ) {
				case 2:
					resolve(res.promise.data as ProfileData);

				case 1:
					resolve((res.promise.data as ProfileDataV1).result);
			}
		})
		.catch(err => {
			reject(err);
		})
	})
}

export default {
	getProfileData,
	changePassword
};